import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { CompetitionSport } from './competition-sport'
import * as fromCompetitionSport from './competition-sport.reducer'

const state = createFeatureSelector<fromCompetitionSport.CompetitionSportState>(
  fromCompetitionSport.FEATURE_NAME
)

const adapter = fromCompetitionSport.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)
const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<CompetitionSport>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: CompetitionSport[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

const selectPaginationDetails = createSelector(
  state,
  (state) => state.paginationDetails
)

export const competitionSportSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectCount,
  selectPaginationDetails
}
